import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator
} from "@/components/ui/dropdown";
import Feedback from "@/components/ui/feedback";
import { BrandedAppFloatingMenuTrigger } from "@/lib/white-label-branding/BrandedAppFloatingMenuTrigger";
import { SharedAppBrandWebsite } from "@/lib/white-label-branding/SharedAppBrandSite";
import { getWhiteLabelBrand } from "@/lib/white-label-branding/getWhiteLabelBrand";
import { Outlet, createFileRoute } from "@tanstack/react-router";
import { BookMarked, Flag, Telescope } from "lucide-react";

function App() {
  const brand = getWhiteLabelBrand();

  return (
    <div className="h-full w-full">
      <Outlet />
      <div className="group select-none absolute bottom-2 right-6 flex flex-col gap-2 items-end text-xs">
        <Feedback>
          {(toggleFeedbackModal) => (
            <DropdownMenu>
              <BrandedAppFloatingMenuTrigger />

              <DropdownMenuContent side="top" align="end">
                <DropdownMenuItem>
                  <SharedAppBrandWebsite brand={brand} />
                </DropdownMenuItem>

                {!brand && (
                  <>
                    <DropdownMenuItem>
                      <a
                        href="https://www.numerous.com/apps"
                        target="_blank"
                        rel="noreferrer"
                        className="cursor-pointer flex gap-2 items-center transition-colors"
                      >
                        <Telescope size={14} />
                        Public Apps
                      </a>
                    </DropdownMenuItem>
                    <DropdownMenuItem>
                      <a
                        href="https://www.numerous.com/docs"
                        target="_blank"
                        rel="noreferrer"
                        className="cursor-pointer flex gap-2 items-center transition-colors"
                      >
                        <BookMarked size={14} />
                        Docs
                      </a>
                    </DropdownMenuItem>
                  </>
                )}

                <DropdownMenuSeparator />
                <button onClick={toggleFeedbackModal} className="w-full">
                  <DropdownMenuItem className="cursor-pointer flex gap-2 items-center transition-colors">
                    <Flag size={14} />
                    Feedback
                  </DropdownMenuItem>
                </button>
              </DropdownMenuContent>
            </DropdownMenu>
          )}
        </Feedback>
      </div>
    </div>
  );
}

export const Route = createFileRoute("/_app-layout")({
  component: App
});
